import styles from './BottomSheet.module.css';

/** The shared sheet's classes a sheet's own footer uses: the pinned, wrapping row of buttons. */
export const sheetStyles = { actions: styles.actions, primary: styles.primary };
